import type { FC } from "react";

import { BatchMoveSiteModal } from "src/app/features/Site/components/buttons/BatchMoveSiteModal";
import { FinishDealerChangeButton } from "src/app/features/Site/components/buttons/FinishDealerChangeButton";
import { SiteBatchUpdateButton } from "src/app/features/Site/components/buttons/SiteBatchUpdateButton";
import { SitesSearchForm } from "src/app/features/Site/components/forms/SitesSearchForm";
import { SitesTable } from "src/app/features/Site/components/tables/SitesTable";
import type { SiteList } from "src/app/features/Site/types/SiteList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";
import { MoveSiteModal } from "../components/buttons/MoveSiteModal";

export const SitesPage: FC<NoneOwnProps> = () => {
    const table = <SitesTable />;
    const searchForm = <SitesSearchForm />;
    const hasAccess = canAccess(ResourceName.SITES, "canRead");

    return (
        <PageLayout name="sites_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.sites" />
                    <ResourceManager<SiteList>
                        useDataGroup
                        dataMapperKey="siteTableData"
                        resource={ResourceName.SITES}
                        table={table}
                        searchForm={searchForm}
                        actions={[
                            Actions.ADD,
                            Actions.DELETE,
                            Actions.FORM_COPY,
                            Actions.EXPORT,
                            Actions.IMPORT_DATA,
                            Actions.DEALER_CHANGE,
                        ]}
                        customActions={[
                            {
                                action: <FinishDealerChangeButton />,
                                permission: "dealerChange",
                            },
                            {
                                action: <MoveSiteModal />,
                                permission: "move",
                            },
                            {
                                action: <BatchMoveSiteModal />,
                                permission: "batchMoveCsv",
                            },
                            {
                                action: <SiteBatchUpdateButton />,
                                permission: "batchUpdate",
                            },
                        ]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
